// The FRONTEND face of this fork's client config — the same shape as the
// product's modules/infrastructure/config/frontend/client.config.js (every
// export is documented there). '@client/config' resolves here in this fork
// (web/vite.config.js).
//
// ONE SOURCE OF TRUTH: these values mirror client-custom/config/client.config.js
// (the server-side seam) — edit BOTH.

export const BRAND_NAME = 'Bendet Group';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Bendet Group — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';
export const SITE_SWITCH_GROUP = 'site-switchers';
export const WORKSPACES_ENABLED = true;

export const STORAGE_PREFIX = 'bendet-group';

export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
export const LINK_TYPE_NAME = 'Hierarchy';

// No board grouping field yet (the server seam's kanban.groupByFieldId).
export const WPO_FIELD = null;

export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

export const CUSTOMS_ALLOWED_HOSTS = [];
